<template>
  <div class="room-actions" v-if="roomId">
    <div class="room-actions__row">
      <div class="room-actions__item" @click="handleAction('door')">
        <div class="room-actions__icon room-actions__icon--green">
          <van-icon name="shop-o" size="20" color="#fff" />
        </div>
        <div class="room-actions__text">开大门</div>
      </div>
      <div class="room-actions__item" @click="handleAction('open')">
        <div class="room-actions__icon room-actions__icon--green">
          <van-icon name="lock" size="20" color="#fff" />
        </div>
        <div class="room-actions__text">开包间</div>
      </div>
      <div class="room-actions__item" @click="handleAction('powerOn')">
        <div class="room-actions__icon room-actions__icon--blue">
          <van-icon name="add-o" size="20" color="#fff" />
        </div>
        <div class="room-actions__text">通电</div>
      </div>
      <div class="room-actions__item" @click="handleAction('powerOff')">
        <div class="room-actions__icon room-actions__icon--red">
          <van-icon name="close" size="20" color="#fff" />
        </div>
        <div class="room-actions__text">断电</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import * as roomApi from '@/api/lxz/room'

export default {
  name: 'RoomActions',
  props: {
    roomId: {
      type: [String, Number],
      default: ''
    },
    roomStatus: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      btnDisabled: false
    }
  },
  computed: {
    normalizedRoomStatus() {
      if (this.roomStatus === '' || this.roomStatus == null) return -1
      const n = Number(this.roomStatus)
      return Number.isNaN(n) ? -1 : n
    }
  },
  methods: {
    async handleAction(type) {
      if (this.btnDisabled) return
      const actions = {
        disable: '禁用',
        enable: '启用',
        open: '开门',
        powerOn: '通电',
        powerOff: '断电'
      }
      const actionText = actions[type] || '操作'
      this.btnDisabled = true
      try {
        await Dialog.confirm({
          title: `确认${actionText}`,
          message: `确认执行${actionText}操作吗？`,
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        })
        Toast.loading('操作中...')
        const roomId = this.roomId
        if (type === 'door') await roomApi.openDoor({ roomId })
        if (type === 'open') await roomApi.openRoom({ roomId })
        if (type === 'powerOn') await roomApi.statePowerRoom({ form: { roomId, power: 'on' } })
        if (type === 'powerOff') await roomApi.statePowerRoom({ form: { roomId, power: 'off' } })

        // Notify({ message: '操作成功', type: 'success' })
        Toast.success('操作成功')
        this.$emit('done', { type })
      } catch (e) {
        const isCancel = e && (e === 'cancel' || e.message === 'cancel')
        if (!isCancel) Toast.fail('操作失败')
      } finally {
        Toast.clear('loading')
        this.btnDisabled = false
      }
    }
  }
}
</script>

<style scoped>
.room-actions {
  margin: 12px 0;
}
.room-actions__row {
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: 16px 0;
  border-radius: 10px;
}
.room-actions__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
}
.room-actions__icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}
.room-actions__icon--green {
  background: linear-gradient(135deg, #41a863, #2b9939);
}
.room-actions__icon--blue {
  background: linear-gradient(135deg, #4cabeb, #2979ff);
}
.room-actions__icon--red {
  background: linear-gradient(135deg, #ff7a00, #ff4d4f);
}
.room-actions__text {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}
</style>
